export default "__VITE_ASSET__BaJb_yHc__"